import * as Yup from 'yup';

/**
 * Write custom validator for Yup checking for comma separated emails
 *
 * @example
 *  import '../../../../../common/formik-material-ui/commaSeparatedEmails';
 *
 *  const QueueEditSchema = Yup.object({
 *    submitQueueEditPayload: Yup.object({
 *      email: Yup.string().commaSeparatedEmails('Invalid email'),
 *    }),
 *  });
 */
Yup.addMethod<Yup.StringSchema>(Yup.string, 'commaSeparatedEmails', function (
  message: string
) {
  return this.test('is-valid-email-list', message, async function (
    value: any
  ): Promise<any> {
    const { path, createError } = this;

    // select Yup validation schema
    const schema = Yup.string().email();

    // find first invalid email in list of emails
    // stop after fist found
    const invalid = value
      ?.split(',')
      .find((email: string) => !schema.isValidSync(email.trim()));

    // return true if all emails are valid or error if one is false
    return (
      !invalid ||
      createError({
        path,
        message,
      })
    );
  });
});
